__turbopack_context__.v({
  "brand": "AppHeader-module-scss-module__SpHqQa__brand",
  "brand-image": "AppHeader-module-scss-module__SpHqQa__brand-image",
  "header": "AppHeader-module-scss-module__SpHqQa__header",
  "header__bar": "AppHeader-module-scss-module__SpHqQa__header__bar",
  "sidebar": "AppHeader-module-scss-module__SpHqQa__sidebar",
});
